import { useContext } from "react";
import { ModalContext } from "./ModalContext";

export const useModal = () => {
  const { modal } = useContext(ModalContext);

  return modal;
};
